module.exports = __webpack_public_path__ + "img/thaisan.f0d6be85.svg";